import React, { Component } from 'react';

class DropDown extends Component {
  render() {
    return (
      <div className={`field-wrapper ${ this.props.labelPositionTop && 'label-on-top' }`}>
        <label className="field-label">{ this.props.label }</label>
        <div className="field">
          <select
            name=""
            id=""
            onChange={(event) => this.onChangeHandler(event)}
            value={this.props.selected}
          >
          {
            this.props.options.map(function(option, key) {
              return (
                <option key={key} value={option.value} >{option.label}</option>
              );
            })
          }
          </select>
        </div>
        {
          this.props.error &&
          <div style={{ color: 'red' }}>
            {this.props.error.map((message) => message)}
          </div>
        }
      </div>
    );
  }

  onChangeHandler(event) {
    // console.log('onChangeHandler', event.target.value);
    this.props.onChangeHandler(event.target.value);
  }
}

export { DropDown };
